import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { PlanckBodyComponent, PlanckBodyType } from "./PlanckBodyComponent";

export class WallBomb extends GameObject {
	img: Phaser.GameObjects.Image;
	explosionSpine: SpineGameObject;
	spineContainer: SpineContainer;
	grounded = false;
	static ON_DESTROYED = "onDestroyed";
	
	constructor(scene: GameScene, x: number, y: number) {
		super(scene);

		this.x = x;
		this.y = y;

		const img = this.img = this.addImage("wallBomb");
		img.setPosition(20, -20);
		const spine = this.explosionSpine = scene.add.spine(0, 0, "explosion-generic");
		spine.visible = false;
		spine.scale = 0.75;
		const spineContainer = this.spineContainer = scene.add.spineContainer(0, 0);
		spineContainer.add(spine);
		this.add(spineContainer);

		const hitboxWidth = 130;
		const hitboxHeight = 130;
		this.setSize(hitboxWidth, hitboxHeight);

		// const hitboxImg = this.addImage("whiteSquare");
		// hitboxImg.setDisplaySize(hitboxWidth, hitboxHeight);
		// hitboxImg.tint = 0xCC5500;
		// hitboxImg.alpha = 0.25;

		const planckBody = this.addComponent(new PlanckBodyComponent(this, PlanckBodyType.BOX, {
			x: this.x, y: this.y,
			width: hitboxWidth, height: hitboxHeight,
			worldScale: GameScene.worldScale,
			isKinematic: true,
			isSensor: false,
		}));
		
		this.addComponent(new DestroyOffscreen(this, true, false));
	}

	playHitAnimation(): void {
		this.img.visible = false;
		this.emit(WallBomb.ON_DESTROYED);
		this.explosionSpine.visible = true;
		this.explosionSpine.play("hit", false);
		this.explosionSpine.on("complete", () => {
			this.destroy();
		});
	}
}